/* eslint-disable @typescript-eslint/no-explicit-any */
import { ValueFormatType } from "@/types/chart";

export const formatNumber = (
  value: string | number,
  options?: Intl.NumberFormatOptions
) => new Intl.NumberFormat("en-US", options).format(Number(value));
export const formatCurrency = (value: string | number) =>
  formatNumber(value, { style: "currency", currency: "USD" });
export const formatPercent = (value: string | number) =>
  formatNumber(value, { style: "percent", maximumFractionDigits: 2 });
export const formatLargeNumber = (value: string | number) =>
  formatNumber(value, { notation: "compact", compactDisplay: "short" });
export const formatLargeCurrency = (value: string | number) =>
  formatNumber(value, {
    notation: "compact",
    compactDisplay: "short",
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  });

export const formatMap: Record<ValueFormatType, (props: any) => string> = {
  number: formatNumber,
  currency: formatCurrency,
  percent: formatPercent,
  "large-number": formatLargeNumber,
  "large-currency": formatLargeCurrency,
  none: (value: any) => value.toString(),
};
